/* eslint-disable jsx-a11y/anchor-is-valid */
import Button from "@hfc/shared/components/Button"
import Link from "next/link"

const GoToMetaverseButton = () => {
	return (
		<div
			className={`fixed bottom-0 left-0 z-30 fixed-overlay`}
		>
			<Link href="/metaverse">
				<a>
					<Button
						className="px-6 py-2 text-md whitespace-nowrap"
						variant="secondary"
					>
						⬅ Metaverse
					</Button>
				</a>
			</Link>
		</div>
	)
}

export default GoToMetaverseButton
